import { Link } from 'gatsby';
import React from 'react';

import { BreadcrumbsContent } from '../../models/app-data-model';
import './breadcrumbs.scss';

export type BreadcrumbsContentProps = {
  breadcrumbsContent: BreadcrumbsContent;
};

const Breadcrumbs: React.FC<BreadcrumbsContentProps> = ({ breadcrumbsContent }: BreadcrumbsContentProps) => {
  const useSubsite = breadcrumbsContent?.subsite?.subsite_name !== breadcrumbsContent.title;
  const useParentSubsite = breadcrumbsContent?.title?.includes('|') || !useSubsite;

  if (breadcrumbsContent.hide_breadcrumbs) {
    return null;
  }
  return (
    <div className="breadcrumbs">
      {breadcrumbsContent && breadcrumbsContent?.subsite && (
        <>
          <div className="anchor-container">
            {useSubsite && (
              <Link
                className="subsite"
                data-testid="testSubsite"
                to={`${
                  useParentSubsite ? breadcrumbsContent?.subsite?.parent_subsite?.[0]?.url_prefix : breadcrumbsContent?.subsite?.url_prefix
                }`}
              >
                {useParentSubsite
                  ? breadcrumbsContent?.subsite?.parent_subsite?.[0]?.subsite_name
                  : breadcrumbsContent?.subsite?.subsite_name}
              </Link>
            )}
          </div>
          <div className={useSubsite ? 'title-container' : ''}>
            <p className="breadcrumbs-title" data-testid="testBreadcrumbsTitle">
              {useSubsite && '/ '}
              {useParentSubsite ? breadcrumbsContent?.subsite?.subsite_name : breadcrumbsContent?.title}
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default Breadcrumbs;
